export default {

  state:{

    mspDocs: null
  },

  
  mutations:{

    resetStateViewCita(state){
      state.mspDocs = null
    },


    setDocsMspCita(state, newData){
      state.mspDocs = newData
    },

  }
}

